import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 引入一级路由
const Loading = () => import('@/pages/Loading/loading');
const LoginSh = () => import('@/pages/login/login-sh'); // 登录 -- 首衡
const loginWx = () => import('@/pages/login/login-wx'); // 登录 -- 望宿
const loginWangxiu = () => import('@/pages/login/login-wangxiu'); // 登录 -- 望宿
const HomeIndex = () => import('@/pages/home/index'); // 首页
const Password = () => import('@/pages/cryptogram/password')// 修改密码

const TradeIndent = () => import('@/pages/iPayment/trade-indent') // 支付管理-交易订单
const NewlyOrders = () => import('@/pages/iPayment/newly-orders') // 支付管理-新增订单
const NewlyOrderPage = () => import('@/pages/iPayment/newly-orderPage') // 支付管理-新增订单（首衡）
const PaymentOrderno = () => import('@/pages/iPayment/payment-orderno') // 支付管理-支付流水
const PendingOrders = () => import('@/pages/iPayment/pending-orders') // 支付管理-挂起订单

const TaskList = () => import('@/pages/task-regulate/task-list') // 任务管理-任务列表
const NewTask = () => import('@/pages/task-regulate/new-task') // 任务管理-新建任务

const RechargeAccount = () => import('@/pages/expense-regulate/recharge-account') // 费用管理-充值账户
const BalanceDetails = () => import('@/pages/expense-regulate/balance-details') // 费用管理-余额明细
const ExpenseDetails = () => import('@/pages/expense-regulate/expense-details') // 费用管理-费用明细
const RechargeRecord = () => import('@/pages/expense-regulate/recharge-record') // 费用管理-充值记录
const RefundRecord = () => import('@/pages/expense-regulate/refund-record') // 费用管理-退款记录
const BusinessStatement = () => import('@/pages/expense-regulate/business-statement') // 费用管理-商户对账单

const UserControl = () => import('@/pages/seller-center/user-control') // 商户中心-用户管理
const UserRegulate = () => import('@/pages/seller-center/user-regulate') // 商户中心-商户管理

const InvoiceDetails = () => import('@/pages/control-overinvoices/invoice-details') // 发票管理-发票明细
const InvoiceApplication = () => import('@/pages/control-overinvoices/invoice-application') // 发票管理-发票申请
const RecipientsRegulate = () => import('@/pages/control-overinvoices/recipients-regulate') // 发票管理-收件人管理

const BillDetails = () => import('@/pages/bill-regulate/bill-details') // 税单管理-税单明细
const taxCalculate = () => import(/* webpackChunkName: "management" */ '@/pages/bill-regulate/tax-calculate'); // 个税计算器


const LogList = () => import('@/pages/system-log/log-list') // 系统日志-日志列表

const downloadRecord = () => import('@/pages/down-center/download-record') // 下载中心-下载记录
const operationRecord = () => import('@/pages/operation-log/operation-record') // 操作日志-操作记录



const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'loginwx',
      component: loginWx
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    },
    {
      path: '/login-sh',
      name: 'loginsh',
      component: LoginSh
    },
    {
      path: '/login-wx',
      name: 'loginwx',
      component: loginWx
    },
    {
      path: '/login-wangxiu',
      name: 'loginwangxiu',
      component: loginWangxiu
    },
    {
      // 首页
      path: '/home',
      name: 'home',
      component: HomeIndex,
      meta: {
        title: "首页",
        canMultipleOpen: true
      },
      children: [
        {
          //修改密码
          path: '/password',
          name: 'password',
          component: Password,
          meta: {
            title: "修改密码",
            canMultipleOpen: true
          }
        },
        {
          path: '/trade-indent',
          name: 'tradeIndent',
          component: TradeIndent,
          meta: {
            title: "交易订单",
          }
        },
        {
          path: '/newly-orders',
          name: 'newlyOrders',
          component: NewlyOrders,
          meta: {
            title: "新增订单",
          }
        },
        // 首衡
        {
          path: '/newly-orderPage',
          name: 'newlyOrderPage',
          component: NewlyOrderPage,
          meta: {
            title: "新增订单",
          }
        },
        {
          path: '/payment-orderno',
          name: 'paymentOrderno',
          component: PaymentOrderno,
          meta: {
            title: "支付流水",
          }
        },
        {
          path: '/pending-orders',
          name: 'pendingOrders',
          component: PendingOrders,
          meta: {
            title: "挂起订单",
          }
        },

        {
          path: '/task-list',
          name: 'taskList',
          component: TaskList,
          meta: {
            title: "任务列表",
          }
        },
        {
          path: '/new-task',
          name: 'newTask',
          component: NewTask,
          meta: {
            title: "新建任务",
          }
        },

        {
          path: '/recharge-account',
          name: 'rechargeAccount',
          component: RechargeAccount,
          meta: {
            title: "充值账户",
          }
        },
        {
          path: '/balance-details',
          name: 'balanceDetails',
          component: BalanceDetails,
          meta: {
            title: "余额明细",
          }
        },
        {
          path: '/expense-details',
          name: 'expenseDetails',
          component: ExpenseDetails,
          meta: {
            title: "费用明细",
          }
        },
        {
          path: '/recharge-record',
          name: 'rechargeRecord',
          component: RechargeRecord,
          meta: {
            title: "充值记录",
          }
        },
        {
          path: '/refund-record',
          name: 'refundRecord',
          component: RefundRecord,
          meta: {
            title: "退款记录",
          }
        },
        {
          path: '/business-statement',
          name: 'businessStatement',
          component: BusinessStatement,
          meta: {
            title: "商户对账单",
          }
        },

        {
          path: '/user-control',
          name: 'userControl',
          component: UserControl,
          meta: {
            title: "用户管理",
          }
        },
        {
          path: '/user-regulate',
          name: 'userRegulate',
          component: UserRegulate,
          meta: {
            title: "商户管理",
          }
        },

        {
          path: '/invoice-details',
          name: 'invoiceDetails',
          component: InvoiceDetails,
          meta: {
            title: "发票明细",
          }
        },
        {
          path: '/invoice-application',
          name: 'invoiceApplication',
          component: InvoiceApplication,
          meta: {
            title: "发票申请",
          }
        },
        {
          path: '/recipients-regulate',
          name: 'recipientsRegulate',
          component: RecipientsRegulate,
          meta: {
            title: "收件人管理",
          }
        },

        {
          path: '/bill-details',
          name: 'billDetails',
          component: BillDetails,
          meta: {
            title: "税单明细",
          }
        },
        {
          path: '/tax-calculate',
          name: 'tax-calculate',
          component: taxCalculate,
          meta: {
            title: "个税计算器",
            canMultipleOpen: true
          }
        },
        {
          path: '/log-list',
          name: 'logList',
          component: LogList,
          meta: {
            title: "日志列表",
          }
        },
        {
          path: '/download-record',
          name: 'downloadrecord',
          component: downloadRecord,
          meta: {
            title: "下载记录",
          }
        },
        {
          path: '/operation-record',
          name: 'operationrecord',
          component: operationRecord,
          meta: {
            title: "操作记录",
          }
        },
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js